import { render } from "./OrderMessagesPanel.vue?vue&type=template&id=40c74184&scoped=true&ts=true"
import script from "./OrderMessagesPanel.vue?vue&type=script&lang=ts"
export * from "./OrderMessagesPanel.vue?vue&type=script&lang=ts"

import "./OrderMessagesPanel.vue?vue&type=style&index=0&id=40c74184&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c74184"]])

export default __exports__